import * as React from 'react'
import { getClientVersion } from '../../api/version'
import MdConfirm from '../widgets/MdConfirm'

export default class VersionManager extends React.Component<any, any> {
  constructor(props) {
    super(props)
    this.state = {
      poll: () => null,
      expired: false
    }
  }

  public async componentDidMount () {
    const version = await getClientVersion()
    const poll = setInterval(async () => {
      const v = await getClientVersion()
      if (v !== version) {
        this.setState({expired: true})
      }
    }, 300000)

    this.setState({poll})
  }

  public componentWillUnmount () {
    clearTimeout(this.state.poll)
  }

  private ignore () {
    this.setState({
      expired: false
    })
  }

  private accept () {
    window.location.reload(true)
  }

  public render() {
    return (
      <div>
        <MdConfirm
          open={this.state.expired}
          confirmCallback={() => this.accept()}
          cancelCallback={() => this.ignore()}
          confirmText={'Upgrade'}
          cancelText={'Later'}
          style={{
            margin: 'auto',
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: '50%',
            height: '122px'
          }}>
          <h2 style={{color: '#999', fontSize: '22px', marginBottom: '10px'}}>
            We have recently released a new version of MetalDesk
          </h2>
          <p style={{color: '#999', fontSize: '16px', marginBottom: '10px'}}>
            Upgrade now, or click 'later' to complete what you are doing
          </p>
        </MdConfirm>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./react/components/containers/VersionManagerContainer.tsx